import { AxiosResponse } from "axios";

import { axios } from "../api";

import { AeronetV6ItemsResponse } from "../types";
import type { ITask } from "./types";

const QUERY_MAX_PAGES = 50;

class JobTaskService {
  public async list(params?: any): Promise<any> {
    // @ts-ignore
    return axios.get(`/v6/tasks`, { params }).then((resp: AxiosResponse<any>) => resp.data);
  }
  public async get(id: number | string): Promise<ITask> {
    // @ts-ignore
    return axios.get(`/v6/tasks/${id}`).then((resp: AxiosResponse<ITask>) => resp.data);
  }

  public async create(data: any): Promise<any> {
    return axios.post(`/v6/tasks`, data).then((resp) => resp.data);
  }

  public async update(id: number | string, data: any): Promise<any> {
    return axios.put(`/v6/tasks/${id}`, data).then((resp) => resp.data);
  }

  public async delete(id: number | string): Promise<any> {
    return axios.delete(`/v6/tasks/${id}`);
  }

  // Every task on the job. GET /v6/jobs/{id}/tasks is paginated server-side
  // (default 50, max 100), so one bare call silently dropped task 51 onwards —
  // an imported Peak WO carries up to 169. Same loop as WorkOrderReportPdfBuilder.
  /** `fresh` skips the response cache — for a reload right after a write. */
  public async query(jobId: number | string, options?: { fresh?: boolean }): Promise<ITask[]> {
    const size = 100;
    const all: ITask[] = [];
    for (let page = 1; page <= QUERY_MAX_PAGES; page += 1) {
      const resp: AxiosResponse<AeronetV6ItemsResponse<ITask>> = await axios.get(
        `/v6/jobs/${jobId}/tasks`,
        { params: { page, size }, ...(options?.fresh ? { cache: false as const } : {}) }
      );
      const items = resp.data?.items ?? [];
      all.push(...items);
      const total = Number(resp.data?.total ?? 0);
      if (items.length < size || all.length >= total) break;
    }
    return all;
  }
}

export let JobTask = new JobTaskService();
export let Task = new JobTaskService();
export type TaskType = ITask;
